// extracted by mini-css-extract-plugin
module.exports = {"media":"styles_media__1DtXM","img_wrap":"styles_img_wrap__3by1I","main_img":"styles_main_img__2befM","event_name":"styles_event_name__2qu_J","url":"styles_url__3agzq"};